import { create } from 'zustand'
import { produce } from 'immer'

import * as THREE from 'three'

export const useAppStore = create((set) => ({

    gameStatus: 'beforeStart',
    setGameStatus: (gameStatus) => {
        set((state) => ({ gameStatus: gameStatus }))
    },

    player: false,
    setPlayer: (m) => {set((state) => ({ player: m }))},

    positions: {
        fox: {
            start: new THREE.Vector3(2, 1.5, 0),
            current: new THREE.Vector3(2, 1.5, 0),
            last: new THREE.Vector3(2, 1.5, 0),
        },
        rabbit: {
            start: new THREE.Vector3(-2, 0, 0),
            current: new THREE.Vector3(-2, 0, 0),
            last: new THREE.Vector3(-2, 0, 0),
        },
    },

    setPositions: (animal, position) => set(
        produce((state) => {
            state.positions[animal].last = state.positions[animal].current.clone();
            state.positions[animal].current = position.clone();
        }
    )),

    rotations: {
        fox: new THREE.Euler(0, 0, 0, 'YXZ'),
        rabbit: new THREE.Euler(0, 0, 0, 'YXZ'),
    },

    setRotation: (animal, rotation) => set(
        produce((state) => {
            state.rotations[animal] = rotation.clone();
        }
    )),

    actions: {
        fox: 'walk',
        rabbit: 'run',
    },

    effectiveTimeScales: {
        fox: 1,
        rabbit: 3,
    },

    setAction: (animal, actionName) => set(
        produce((state) => {
            state.actions[animal] = actionName
        }
    )),

    movements: {
        fox: {},
        rabbit: {
            directionX: 1,
            directionZ: 1,
            stepCountX: 0,
            stepCountZ: 0,
        },
    },

    setMovements: (animal, m, v) => set(
        produce((state) => {
            state.movements[animal][m] = v
        }
    )),

}))

